export default __webpack_public_path__ + "KaTeX_SansSerif-Regular.a4fd05630bcdec90cc1a744cc7462c35.woff";